import { useLocation, useNavigate } from 'react-router-dom';

import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Paper from '@mui/material/Paper';

import EnergySavingsLeafIcon from '@mui/icons-material/EnergySavingsLeaf';
import GrainIcon from '@mui/icons-material/Grain';
import LanguageIcon from '@mui/icons-material/Language';

import { RouterPaths } from '@/components/pages';

function MobileBottomNavigation() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (_event: React.SyntheticEvent, value: number) => {
    switch (value) {
      case 0:
        navigate(RouterPaths.emissionsAndEnergy);
        break;
      case 1:
        navigate(RouterPaths.manageCo2e);
        break;
    }
  };

  let navigationValue = 0;
  switch (location.pathname) {
    case RouterPaths.emissionsAndEnergy:
      navigationValue = 0;
      break;
    case RouterPaths.manageCo2e:
      navigationValue = 1;
      break;
  }

  return (
    <Paper
      sx={(theme) => ({
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: theme.zIndex.appBar,
      })}
      elevation={4}
    >
      <BottomNavigation
        showLabels
        value={navigationValue}
        onChange={handleChange}
      >
        <BottomNavigationAction
          label="Emissions"
          icon={<EnergySavingsLeafIcon />}
        />
        <BottomNavigationAction label="Manage CO₂e" icon={<LanguageIcon />} />
        <BottomNavigationAction label="Event Map" icon={<GrainIcon />} />
      </BottomNavigation>
    </Paper>
  );
}

export { MobileBottomNavigation };
